import script from "./InfoBox.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoBox.vue?vue&type=script&setup=true&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=0b1fb25e&lang=css"
/* custom blocks */
import block0 from "./InfoBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__